var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth_title_wrapper"},[_vm._m(0),_c('div',{staticClass:"slots_text static_text"},[_vm._t("title")],2),_c('div',{staticClass:"slots_text text-capitalize"},[_vm._t("title_two")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img_wrapping"},[_c('img',{attrs:{"src":require("@/assets/images/authlogo.png"),"alt":"authLogo","draggable":"false"}})])
}]

export { render, staticRenderFns }